module.exports = __webpack_public_path__ + "img/smart-currency-popup.1bd53dc3.png";